import { Tooltip as AntdTooltip } from 'antd';
import 'antd/es/tooltip/style/index.css';
import './index.less';

const ToolTip = AntdTooltip;

export default ToolTip;
